import * as React from "react";
import type { SVGProps } from "react";
export const SvgLolRanksIron = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 20 20" {...props}>
    <path
      fill="#51484A"
      fillRule="evenodd"
      d="M6.095 11.633c0-.577.13-1.148.38-1.67s.613-.982 1.064-1.348c-1.924-.671-4.723-2.01-5.537-4.269 0 0-.173 2.289 1.212 4.85 0 0 1.472.956 2.06 2.244l-1.143-.7c.289.92.643 1.816 1.06 2.685.665 1.268 1.904 2.227 1.904 2.227s-.576-1.713.1-1.302l.066.045a3.86 3.86 0 0 1-1.168-2.77l.002.008Zm6.421-3.035c.458.365.827.828 1.081 1.353a3.87 3.87 0 0 1 .243 2.724 3.877 3.877 0 0 1-.936 1.629c.5-.156 0 1.35 0 1.35s1.237-.963 1.903-2.227c.418-.868.772-1.765 1.06-2.683l-1.135.686c.594-1.282 2.054-2.234 2.054-2.234 1.385-2.561 1.212-4.85 1.212-4.85-.802 2.24-3.561 3.574-5.482 4.252Zm.213 3.035c0 1.472-1.205 2.664-2.69 2.664-1.487 0-2.691-1.193-2.691-2.664 0-1.47 1.204-2.663 2.69-2.663s2.69 1.192 2.69 2.663Z"
      clipRule="evenodd"
    />
  </svg>
);
